$('ul.tabs').on('click', 'li:not(.current)', function () {
    $(this).addClass('active').siblings().removeClass('active')
        .parents('div.tabs-content')
        .find('>div.tabs-panel')
        .hide()
        .eq($(this).index())
        .fadeIn(500);
});